function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "101.7%",
  height: "117.8%",
  x: "-.8%",
  y: "-8.9%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0 0.56555591 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3CB09F",
  fillRule: "nonzero",
  d: "M1007.178 50h9.002a2.82 2.82 0 0 1 2.82 2.82v74.36a2.82 2.82 0 0 1-2.82 2.82h-9.002a2.82 2.82 0 0 1-2.82-2.82V52.82a2.82 2.82 0 0 1 2.82-2.82zm-34.453 30h9.002a2.82 2.82 0 0 1 2.82 2.82v44.36a2.82 2.82 0 0 1-2.82 2.82h-9.002a2.82 2.82 0 0 1-2.82-2.82V82.82a2.82 2.82 0 0 1 2.82-2.82zm-34.452-30h9.002a2.82 2.82 0 0 1 2.82 2.82v74.36a2.82 2.82 0 0 1-2.82 2.82h-9.002a2.82 2.82 0 0 1-2.82-2.82V52.82a2.82 2.82 0 0 1 2.82-2.82zM903.82 80h9.002a2.82 2.82 0 0 1 2.82 2.82v44.36a2.82 2.82 0 0 1-2.82 2.82h-9.002a2.82 2.82 0 0 1-2.82-2.82V82.82a2.82 2.82 0 0 1 2.82-2.82z",
  filter: "url(#a)",
  opacity: 0.17,
  transform: "translate(-897 -46)"
});

const SvgIcBannerCloudInsights = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 92,
    viewBox: "0 0 130 92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcBannerCloudInsights, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-banner-cloud-insights.eeeb034e.svg";
export { ForwardRef as ReactComponent };